<template>
  <div class="rootIndex2025">
    <header style="border-bottom:none;">
      <!-- 左侧LOGO -->
      <img
        class="logo"
        src="../../../assets/images/ICodeLogo2.png"
        @click="toICode"
      />
      
      <!-- 导航栏按钮 -->
      <nav>
        <div v-for="item in bannerLinks" class="navlink">
          <a :href="item.link" target="_blank">{{item.name}}</a>
        </div>
      </nav>
    </header>

    <main>
      <router-view />
    </main>


  </div>
</template>

<script>
import MediaUtils from "@/utils/MediaUtils";
import { eventInfo } from "./eventConfig";
import I18nUtils from "@/utils/i18nUtils";

export default {
  data() {

    return {
      bannerLinks: eventInfo().bannerLinks,
      eventCode: eventInfo().eventCode,
      channel: eventInfo().channel
    };

  },

  methods: {
    toICode() {
      this.$router.push({ path: "/" + this.channel });
    },
  },

  mounted() {
    MediaUtils.checkDevice();
    I18nUtils.initLanguage(this);
  },
};
</script>

<style lang="scss">
.rootIndex2025{
  header {
    // box-sizing: border-box;
    position:fixed;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    background-color: #4e54c8;
    width: 100%;
    z-index: 10;

    nav {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: row;
    }
    .logo {
      margin: 0 20px 0 20px;
      transform: scale(0.8);
      height: 100%;
      cursor: pointer;
    }
    .btn {
      cursor: pointer;
    }
    .navlink {
      display: flex;
      justify-content: flex-end;
      font-size: 18px;
      margin-right: 20px;
      border: 2px solid rgb(59, 232, 255);
      border-radius: 5px;
      box-shadow: 0px 0px 2px 2px rgba(59, 232, 255,0.3);
      transition: 0.4s ease;
      cursor: pointer;
      &:hover {
        background: #333;
        a {
          color: #fff;
        }
      }
    }

    a {
      display: block;
      text-decoration: none;
      color: rgb(59, 232, 255);
      padding: 5px 10px;
      // font-weight: bold;
      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }

  main {
    min-height: calc(80vh - 300px);
  }

  footer {
    height: 50px;
    line-height: 50px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    background-color: #435061;
    position: fixed;
    bottom: 0px;
    width: 100%;

    span {
      margin: 0 10px;

      a {
        color: #fff !important;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/contest/2025_final/index.vue